import { render, staticRenderFns } from "./ABreportDefault.vue?vue&type=template&id=61d5feec&scoped=true"
import script from "./ABreportDefault.vue?vue&type=script&lang=js"
export * from "./ABreportDefault.vue?vue&type=script&lang=js"
import style0 from "./ABreportDefault.vue?vue&type=style&index=0&id=61d5feec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d5feec",
  null
  
)

export default component.exports